var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleIconAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8299 8.17984C15.8299 7.65317 15.7833 7.15317 15.7033 6.6665H8.16992V9.67317H12.4833C12.2899 10.6598 11.7233 11.4932 10.8833 12.0598V14.0598H13.4566C14.9633 12.6665 15.8299 10.6132 15.8299 8.17984Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.1693 16.0002C10.3293 16.0002 12.136 15.2802 13.456 14.0602L10.8826 12.0602C10.1626 12.5402 9.2493 12.8335 8.1693 12.8335C6.08263 12.8335 4.31596 11.4269 3.68263 9.52686H1.0293V11.5869C2.34263 14.2002 5.04263 16.0002 8.1693 16.0002Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.68325 9.52691C3.51659 9.04691 3.42992 8.53357 3.42992 8.00024C3.42992 7.46691 3.52325 6.95357 3.68325 6.47357V4.41357H1.02992C0.483251 5.49357 0.169918 6.70691 0.169918 8.00024C0.169918 9.29357 0.483251 10.5069 1.02992 11.5869L3.68325 9.52691Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.1693 3.16667C9.3493 3.16667 10.4026 3.57334 11.236 4.36667L13.516 2.08667C12.136 0.793334 10.3293 0 8.1693 0C5.04263 0 2.34263 1.8 1.0293 4.41334L3.68263 6.47334C4.31596 4.57334 6.08263 3.16667 8.1693 3.16667Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIconAvatar);
export default __webpack_public_path__ + "static/media/google-icon-avatar.8c6645444b2a18706fd83021cb673da6.svg";
export { ForwardRef as ReactComponent };